"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base class for workflow services
 */
var ServiceBase = /** @class */ (function () {
    function ServiceBase(serviceApiUrlKey, applicationPropertiesService) {
        this.loadedServiceUrl = applicationPropertiesService
            .getProperty(serviceApiUrlKey)
            .catch(this.handleError);
    }
    /**
     * Convert object to Map class
     * @param obj object to be converted
     * @returns {Map<number, string>} converted object
     */
    ServiceBase.prototype.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var prop = _a[_i];
            strMap.set(Number(prop), obj[prop]);
        }
        return strMap;
    };
    /**
     * Handle errors
     */
    ServiceBase.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Promise.reject(errMsg);
    };
    return ServiceBase;
}());
exports.ServiceBase = ServiceBase;
//# sourceMappingURL=ServiceBase.js.map